import { fetchAdministrationAudit, mergeAdministrationAuditPages } from "../../api/administrationOperations";
import { AdministrationSlice, AuditSlice, errorMessage } from "./types";

const requests = new Map<string, Promise<void>>();
let generation = 0;
export const auditInitialState = { auditEvents: [], auditFetchedAt: null, auditNextCursor: null, auditTotal: 0, auditSeverityTotals: { critical: 0, error: 0, warning: 0, info: 0 }, auditQuery: { q: "", severity: "", category: "", dateFrom: "", dateTo: "", limit: 25, offset: 0, sort: "occurred", direction: "descending" }, auditHydrated: false, auditLoading: false, auditLoadingMore: false, auditError: "" };
export const resetAuditRequests = () => { generation += 1; requests.clear(); };
export const createAuditSlice: AdministrationSlice<AuditSlice> = (set, get) => ({
  ...auditInitialState,
  loadAudit: (query = {}, force = false) => {
    const nextQuery = { ...get().auditQuery, ...query };
    const key = JSON.stringify(nextQuery);
    const same = JSON.stringify(nextQuery) === JSON.stringify(get().auditQuery);
    if (!force && same && get().auditHydrated) return Promise.resolve();
    const pending = requests.get(key); if (pending) return pending;
    const currentGeneration = ++generation;
    set({ auditQuery: nextQuery, auditLoading: true, auditError: "" });
    const request = fetchAdministrationAudit(nextQuery)
      .then((page) => { if (currentGeneration === generation) set({
        auditEvents: page.items,
        auditFetchedAt: Date.now(),
        auditNextCursor: page.nextCursor,
        auditTotal: Number.isFinite(page.total) ? page.total : page.items.length,
        auditSeverityTotals: {
          critical: page.severityTotals?.critical || 0,
          error: page.severityTotals?.error || 0,
          warning: page.severityTotals?.warning || 0,
          info: page.severityTotals?.info || 0,
        },
        auditHydrated: true,
      }); })
      .catch((error) => { if (currentGeneration === generation) set({ auditError: errorMessage(error, "Unable to load audit log.") }); throw error; })
      .finally(() => { requests.delete(key); if (currentGeneration === generation) set({ auditLoading: false }); });
    requests.set(key, request); return request;
  },
  loadMoreAudit: async () => {
    const state = get(); if (!state.auditNextCursor || state.auditLoading || state.auditLoadingMore) return;
    const cursor = state.auditNextCursor; set({ auditLoadingMore: true, auditError: "" });
    try {
      const page = await fetchAdministrationAudit({ ...state.auditQuery, cursor });
      if (get().auditNextCursor !== cursor) return;
      set((current) => ({ auditEvents: mergeAdministrationAuditPages({ items: current.auditEvents, nextCursor: current.auditNextCursor, total: current.auditTotal, severityTotals: current.auditSeverityTotals, limit: current.auditQuery.limit, offset: current.auditQuery.offset }, page).items, auditNextCursor: page.nextCursor }));
    } catch (error) { set({ auditError: errorMessage(error, "Unable to load more audit events.") }); throw error; }
    finally { set({ auditLoadingMore: false }); }
  },
});
